module.exports = __webpack_public_path__ + "img/FONDOPANTCDMX02.6da80eaf.png";